import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  sidebarVisibility: any
  role: any
  isTablet: any
  isDesktopDevice: any
  isMobile: any;
  DefaultPrompts: any[] = [];
  selectedTemplate: any;
  isEnableDataInsight: any;

  modelsList: any[] = [];
  selectedModel: any = null;
  isApiFlight: boolean = false;

  constructor(
    private commonservice: CommonService,
    private deviceService: DeviceDetectorService,
    private router: Router,
    private messageService: MessageService
  ) {
    let deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }

  ngOnInit(): void {
    this.role = localStorage.getItem('role')
    this.isEnableDataInsight = localStorage.getItem('enableDataInsight')
    if (this.isMobile) {
      this.sidebarVisibility = false
    }
    else {
      this.commonservice.getshowhidesidebar.subscribe((data: any) => {
        this.sidebarVisibility = data
      })
    }
    this.fetchTemplates();
    this.fetchModels();
  }
  reloadSavedAnswer(event: MouseEvent) {
    if (this.router.url === '/saved-answer') {
      event.preventDefault(); // prevent normal navigation
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/saved-answer']);
      });
    }
    // else, allow routerLink to navigate normally
  }
  showhidesidebar() {
    if (this.isDesktopDevice || this.isTablet) {
      this.commonservice.setSidebar(!this.sidebarVisibility)
    }
  }
  onTaskWorkClick() {

    if (!this.selectedTemplate && this.DefaultPrompts.length > 0) {
      this.selectTemplate(this.DefaultPrompts[0]);
    }
  }
  fetchTemplates() {
    this.commonservice.getMethod('api/v1/list_templates?template_type=task')
      .subscribe((data: any) => {
        this.DefaultPrompts = data.data || [];
        this.DefaultPrompts.sort((a, b) => {
          return a.template_code === 'SYSTASK' ? -1 :
            b.template_code === 'SYSTASK' ? 1 : 0;
        });
        localStorage.setItem('tagList', JSON.stringify(this.DefaultPrompts));
      });
  }


  selectTemplate(template: any) {
    this.selectedTemplate = template;
    this.router.navigate(['/task-work']);
    // .this.commonservice.setTemplate(JSON.stringify(template));
    this.commonservice.setSelectedTemplate(JSON.stringify(template));
    // localStorage.setItem('temp_Data', JSON.stringify(template));
  }

  fetchModels() {
    this.isApiFlight = true;
    this.commonservice.getProfundityMethod('models/getModels').subscribe({
      next: (res: any) => {
        this.isApiFlight = false;
        let models: any[] = [];
        let selected: any = null;

        if (res) {
          const apiData = res.data || res;

          if (Array.isArray(apiData)) {
            models = apiData;
          } else if (Array.isArray(apiData.available)) {
            models = apiData.available;
            selected = apiData.selected || apiData.selected_model || apiData.selectedModel;
          } else if (Array.isArray(apiData.models)) {
            models = apiData.models;
            selected = apiData.selected_model || apiData.selectedModel || apiData.selected;
          } else if (apiData.modelsList && Array.isArray(apiData.modelsList)) {
            models = apiData.modelsList;
            selected = apiData.selected_model || apiData.selectedModel || apiData.selected;
          }
        }

        // Normalize models list to {label, value}
        this.modelsList = models.map((model: any) => {
          if (typeof model === 'string') {
            return { label: model, value: model };
          }
          return {
            label: model.label || model.name || model.value || JSON.stringify(model),
            value: model.value !== undefined ? model.value : model
          };
        });

        // Set selected model value
        if (selected) {
          this.selectedModel = typeof selected === 'object' ? (selected.value !== undefined ? selected.value : selected) : selected;
        } else if (this.modelsList.length > 0) {
          this.selectedModel = this.modelsList[0].value;
        }
      },
      error: (err: any) => {
        this.isApiFlight = false;
        console.error('Failed to fetch models', err);
      }
    });
  }

  onModelChange(event: any) {
    const selectedValue = event.value;
    if (!selectedValue) return;

    this.isApiFlight = true;
    const payload = { model: selectedValue };

    this.commonservice.putProfundityMethod('models/select', payload).subscribe({
      next: (response: any) => {
        this.isApiFlight = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Model updated successfully'
        });
      },
      error: (err: any) => {
        this.isApiFlight = false;
        console.error('Failed to update model:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || err?.message || 'Failed to update model'
        });
        this.fetchModels(); // Re-sync active state on error
      }
    });
  }


}
